import { RootState } from '@ui/store';

const selectQuoteBuilderPartInsights = (state: RootState) =>
  state.quoteBuilderPartInsights ?? {};

export const selectIsLoadingPartInsights = (
  state: RootState,
  quoteLineUuid: string,
) => {
  return (
    selectQuoteBuilderPartInsights(state)?.[quoteLineUuid]
      ?.loadingPartInsight ?? false
  );
};

export const selectPartInsightsByQuoteLineUuid = (
  state: RootState,
  quoteLineUuid: string,
) => {
  return (
    selectQuoteBuilderPartInsights(state)?.[quoteLineUuid]?.partInsights ?? null
  );
};

export const selectOrderOrQuoteWithMatchingId = (
  state: RootState,
  quoteLineUuid: string,
) => {
  return selectPartInsightsByQuoteLineUuid(state, quoteLineUuid)
    ?.crossSitePartId?.orderOrQuoteWithMatchingId;
};

export const selectIsLoadingMatchingIdInsight = (
  state: RootState,
  quoteLineUuid: string,
) => {
  return (
    selectQuoteBuilderPartInsights(state)?.[quoteLineUuid]
      ?.loadingMatchingIdInsight ?? false
  );
};
